import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import localeInfo from '@/config/locale';

type IntlProviderProps = {
  locale: string;
  children: React.ReactNode;
}

const IntlProvider = observer(({ locale: _locale, children } : IntlProviderProps) => {
  const locale = useMemo(() => localeInfo[_locale] || localeInfo['zh-CN'], [_locale]);

  return (
    <ReactIntlProvider locale={_locale} messages={locale.messages}>
      {children}
    </ReactIntlProvider>
  );
});

export default IntlProvider;
